import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import { SimpleLoadingComponent } from '../../utils/apollo';
import VisitsAvailabilitySingle from './visits-availability-single';

const query = gql`
  query VisitsAvailability($schoolId: String!, $fromDate: OrdinalDate!, $toDate: OrdinalDate!, $nextDate: String!) {
    highSchoolBySchoolId(id: $schoolId) {
      id
      name
      repVisitsAccount {
        id
        firstVisitDay
        lastVisitDay
        availabilityVisible
        webInstructions
        availabilitySettings {
          rsvpDeadline
        }
      }
      repVisitsAvailability(fromDate: $fromDate, toDate: $toDate) {
        id
        date
        status
        appointments {
          id
          bookedByCollege
          startTime
          status
          maxColleges
          currentColleges
          visitLocationType
        }
      }
      repVisitsNextAppointmentDate(fromDate: $nextDate) {
        date
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ schoolId, fromDate, toDate }) => ({
    variables: {
      schoolId,
      fromDate,
      toDate,
      nextDate: toDate,
    },
    fetchPolicy: 'cache-and-network',
  }),
});

export default SimpleLoadingComponent(graphqlData)(VisitsAvailabilitySingle);
